<template>
  <v-col v-if="isChannelActive" cols="12" sm="6">
    <v-container class="message-container d-flex align-center email-card">
      <v-container>
        <v-row justify="center">
          <v-col cols="12" class="text-center btn-add-channel">
            <v-icon class="email-icon">{{ channel.icon }}</v-icon>
            <div class="email-text">{{ channel.name }}</div>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" class="text-center">
            <mf-button label="Adicionar canal" outlined icon="add" color="marca-0-l10" :disabled="disabled" @click="addChannel" />
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </v-col>
</template>

<script>
export default {
  name: 'EmptyChannelCard',
  props: {
    settingsId: {
      type: String,
      required: true,
    },
    channel: {
      type: Object,
      required: true,
    },
    channels: {
      type: Object,
      required: true,
    },
    isChannelActive: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['update-channel'],
  computed: {
    mapChannelsNames() {
      return {
        SMS: 'sms',
        'Push App': 'push',
        'E-mail': 'email',
        WhatsApp: 'whatsapp',
      }
    },
  },
  methods: {
    addChannel() {
      const channelName = this.mapChannelsNames[this.channel.name]
      this.$bus.$emit('set-selected-channel', { channelName, settingsId: this.settingsId, isEditing: false })
    },
  },
}
</script>

<style lang="scss" scoped>
.message-container {
  padding: 8px;
  gap: 20px;
  height: 200px;
}

.btn-add-channel {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.email-card {
  background-color: rgba(210, 233, 255, 0.2);
  border: 1px solid #d2e9ff;
  border-radius: 16px;
  padding: 20px;
  text-align: center;
  margin: auto;
}

.email-icon {
  font-size: 28px;
  color: $marca-0-l20;
}

.email-text {
  font-size: 16px;
  color: $marca-0-l20;
  letter-spacing: 0.4px;
  font-family: 'Lato', sans-serif;
}
</style>
